import React, { useState, useEffect } from 'react';
import { Button } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const listTypes = [
  { icon: 'list', value: 'unstyled' },
  { icon: 'list ul', value: 'unordered-list-item' },
  { icon: 'list ol', value: 'ordered-list-item' },
];

const List = props => {
  const enabledEditorId = useSelector(state => state.design.enabledEditorId);
  const textBlockType = useSelector(state => state.design.textBlockType);
  const [listTypeIndex, setListTypeIndex] = useState(0);

  useEffect(() => {
    const index = listTypes.map(e => e.value).indexOf(textBlockType);
    setListTypeIndex(index >= 0 ? index : 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textBlockType]);

  const onToggle = e => {
    e.preventDefault();
    const nextIndex = (listTypeIndex + 1) % 3;
    setListTypeIndex(nextIndex);

    const newStyle = {
      type: 'list',
      all: props.entityId !== enabledEditorId,
      value: listTypes[nextIndex].value,
    };
    props.onChange(newStyle);
  };

  return <Button icon={listTypes[listTypeIndex].icon} onMouseDown={onToggle} />;
};

List.propTypes = {
  entityId: PropTypes.number,
  onChange: PropTypes.func,
  ids: PropTypes.any,
};

export default List;
